module.exports = __webpack_public_path__ + "static/media/logo-microsoft-intune-landscape-1.b511377f.jpg";